import React from "react";
import { IconButton } from "@material-ui/core";
import AddShoppingCart from "@material-ui/icons/AddShoppingCart";
import RemoveShoppingCart from "@material-ui/icons/RemoveShoppingCart";

export default ({ input, itemId }) => {
  const { value, onChange } = input;

  const selected = value.has(itemId);

  return (
    <IconButton
      onClick={() =>
        selected ? onChange(value.delete(itemId)) : onChange(value.add(itemId))
      }
    >
      {selected ? <RemoveShoppingCart /> : <AddShoppingCart />}
    </IconButton>
  );
};
